<template>
  <v-container fluid class="pa-12" style="max-width: 1344px;">
    <v-card
      flat
      v-for="(record, index) in webpagepermission"
      :key="index"
      class="elevation-5 mb-3"
    >
      <v-card-text>
        <v-row align="start" justify="center" class="px-12">
          <v-col cols="12" sm="6" md="6">{{ record.permissionName }}</v-col>
          <v-col cols="12" sm="6" md="6">
            <v-checkbox
              v-for="(webpages, index1) in record.webpage"
              :key="index1"
              :label="webpages.webPageName"
              :value="webpages.webPageId"
              false-value="false"
              true-value="true"
              v-model="webpages.authorized"
              :v-bind:id="webpages.webPageId"
              @click="checkboxUpdated()"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'
export default {
  name: 'admin_dashboard',
  data: () => ({
    webpagepermission: null,
    loading: false,
    enabled: true
  }),

  created() {
    this.initialize()
  },
  methods: {
    initialize() {
      ApiService.get('/WebPagePermission')
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.webpagepermission = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    checkboxUpdated() {
      var webpagePermissionClass = this.webpagepermission

      ApiService.put('/WebPagePermission', { webpagePermissionClass })
        .then(res => {
          if (res.data.success) {
            this.$swal('', res.data.respond, 'success').then(function() {})
          } else {
            this.$swal('', res.data.error, 'error')
          }
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
